// ISO weekdays: Monday = 1 … Sunday = 7, as schedules store a weekly run day
export const ISO_WEEKDAYS = {
  MONDAY: 1,
  TUESDAY: 2,
  WEDNESDAY: 3,
  THURSDAY: 4,
  FRIDAY: 5,
  SATURDAY: 6,
  SUNDAY: 7
} as const;

// Weekday names, as schedules that store a weekly run day by name send and accept it
export const WEEKDAY_NAMES = {
  MONDAY: 'monday',
  TUESDAY: 'tuesday',
  WEDNESDAY: 'wednesday',
  THURSDAY: 'thursday',
  FRIDAY: 'friday',
  SATURDAY: 'saturday',
  SUNDAY: 'sunday'
} as const;

/** One weekday name from {@link WEEKDAY_NAMES}. */
export type WeekdayName = (typeof WEEKDAY_NAMES)[keyof typeof WEEKDAY_NAMES];

/** Weekday name of each ISO weekday, for schedules that store the run day by name. */
export const WEEKDAY_NAME_BY_ISO_WEEKDAY = {
  [ISO_WEEKDAYS.MONDAY]: WEEKDAY_NAMES.MONDAY,
  [ISO_WEEKDAYS.TUESDAY]: WEEKDAY_NAMES.TUESDAY,
  [ISO_WEEKDAYS.WEDNESDAY]: WEEKDAY_NAMES.WEDNESDAY,
  [ISO_WEEKDAYS.THURSDAY]: WEEKDAY_NAMES.THURSDAY,
  [ISO_WEEKDAYS.FRIDAY]: WEEKDAY_NAMES.FRIDAY,
  [ISO_WEEKDAYS.SATURDAY]: WEEKDAY_NAMES.SATURDAY,
  [ISO_WEEKDAYS.SUNDAY]: WEEKDAY_NAMES.SUNDAY
} as const satisfies Record<(typeof ISO_WEEKDAYS)[keyof typeof ISO_WEEKDAYS], WeekdayName>;

// Calendar periods a chart over time groups its points by
export const CALENDAR_INTERVAL = {
  WEEKLY: 'weekly',
  MONTHLY: 'monthly',
  QUARTERLY: 'quarterly',
  YEARLY: 'yearly'
} as const;
